// extracted by mini-css-extract-plugin
module.exports = {"transWrapper":"Checkbox_transWrapper__eDu5Q","checkboxClass":"Checkbox_checkboxClass__rpTAP"};